(function ($) {

	/**
	 * Apply coupon
	 */
	function apply_coupon_form_submit($element) {

		let $input = $element.closest('.checkout-coupon-form').find('input[name="coupon_code"]');
		if(!$input.length){
			return false;
		}


		let url = ghostpress_params.ajax_url + "&action=apply_coupon",
			data = {coupon_code: $input.val()};

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		});
		return false;
	}

	// input confirmation
	jQuery(document.body).on('keypress', '.checkout_review__coupon_code', function(e) {
		// If the user presses the "Enter" key on the keyboard
		if (e.key === "Enter") {
			e.preventDefault()
			apply_coupon_form_submit($(this))
		}
	});

	// button click
	jQuery(document.body).on('click', '.checkout_review__coupon_submit', function(e) {
			e.preventDefault()
			apply_coupon_form_submit($(this))
	});


	/**
	 * Remove coupon
	 */
	jQuery(document.body).on('click', '.woocommerce-remove-coupon[data-coupon]', function(e) {
		e.preventDefault()
		let url = ghostpress_params.ajax_url + "&action=remove_coupon",
			data = {
				coupon_code: $(this).data('coupon')
			};

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		});
		return false;
	});

})(jQuery);